import urls from '../api_urls/search'
import { _post } from '@/axios/request'

const suggestMap = {
  brand: urls.GET_SUGGEST_BRAND,
  goods: urls.GET_SUGGEST_PRODUCT,
  inci: urls.GET_SUGGEST_INCI,
  product: urls.GET_SUGGEST_BASF_PRODUCT,
  concept: urls.GET_SUGGEST_CONCEPT,
  formulation: urls.GET_SUGGEST_FORMULATION,
  document: urls.GET_SUGGEST_DOCUMENT,
  general: urls.GET_SUGGEST_GENERAL,
  trend: urls.GET_SUGGEST_TREND,
  media: urls.GET_SUGGEST_MEDIA,
  event: urls.GET_SUGGEST_EVENT
}

// 获取brand列表
export function getBrandList (params) {
  return _post(urls.GET_BRAND_LIST, {
    ...params,
    throwException: false
  })
}

// 获取goods列表
export function getGoodsList (params) {
  return _post(urls.GET_GOODS_LIST, {
    ...params,
    throwException: false
  })
}

// 获取inci列表
export function getInciList (params) {
  return _post(urls.GET_INCI_LIST, {
    ...params,
    throwException: false
  })
}

// 获取basf product列表
export function getProductList (params) {
  return _post(urls.GET_PRODUCT_LIST, {
    ...params,
    throwException: false
  })
}

// 获取concept列表
export function getConceptList (params) {
  return _post(urls.GET_CONCEPT_LIST, {
    ...params,
    throwException: false
  })
}

// 获取配方列表
export function getFormulationList (params) {
  return _post(urls.GET_FORMULATION_LIST, {
    ...params,
    throwException: false
  })
}

// 获取document列表
export function getDocumentList (params) {
  return _post(urls.GET_DOCUMENT, {
    ...params,
    throwException: false
  })
}

// 获取trend列表
export function getTrendList (params) {
  return _post(urls.GET_TREND, {
    ...params,
    throwException: false
  })
}
// 获取media列表
export function getMediaList (params) {
  return _post(urls.GET_MEDIA, {
    ...params,
    throwException: false
  })
}

// 获取搜索建议
export function getSuggest (type, params) {
  const url = suggestMap[type]
  if (url) {
    return _post(url, {
      ...params,
      throwException: false
    })
  }
}



// WEBPACK FOOTER //
// ./src/axios/api/search.js